// Live failures are failures. Demo state must never impersonate a saved proposal.
export async function submitKbDraft(api, { slug, baseVersion, baseMarkdown, proposedMarkdown, summary }) {
  if (!api?.kbSubmit) throw new Error('The approval service is unavailable. Your draft is unchanged.');
  const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(baseMarkdown ?? ''));
  const baseDigest = Array.from(new Uint8Array(hash), b => b.toString(16).padStart(2, '0')).join('');
  const response = await api.kbSubmit({ slug, proposed_markdown: proposedMarkdown, summary,
    base_version: baseVersion ?? null, base_digest: baseDigest });
  if (!response?.proposal?._id || response.proposal.slug !== slug || response.proposal.status !== 'pending_review')
    throw new Error('The service did not confirm a saved proposal. Reload the queue before retrying.');
  return response.proposal;
}
export async function decideKbProposal(api, key, decision, note) {
  if (!api?.kbDecide) throw new Error('The approval service is unavailable. No decision was recorded.');
  const response = await api.kbDecide(key, { decision, note });
  const expected = { approve: 'approved', reject: 'rejected', request_changes: 'changes_requested' }[decision];
  if (!response?.proposal?._id || response.proposal.id !== key || response.proposal.status !== expected)
    throw new Error('The service did not confirm the decision. Reload before retrying.');
  return response;
}
